"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
import { Children, cloneElement, forwardRef, isValidElement } from "react";
const VARIANT_STYLES = {
    primary: "app-btn-primary",
    secondary: "app-btn-secondary",
    ghost: "rounded-2xl px-3 py-2 text-sm font-medium text-white/80 transition hover:bg-white/5",
    destructive: "app-btn-destructive",
    accent: "app-btn-accent",
};
const SIZE_STYLES = {
    sm: "text-xs",
    md: "text-sm",
};
export const Button = forwardRef(({ variant = "secondary", size = "md", className, asChild, children, ...props }, ref) => {
    const classes = clsx("inline-flex items-center justify-center gap-2", VARIANT_STYLES[variant], SIZE_STYLES[size], "disabled:cursor-not-allowed disabled:opacity-60", className);
    if (asChild) {
        const child = Children.only(children);
        if (isValidElement(child)) {
            return cloneElement(child, {
                ...props,
                ref,
                className: clsx(classes, String(child.props.className ?? "")),
            });
        }
    }
    return (_jsx("button", { ref: ref, className: classes, ...props, children: children }));
});
Button.displayName = "Button";
